/** User-facing copy for any subscribe failure. The Errors below stay diagnostic, for the console. */
export const GENERIC_SUBSCRIBE_ERROR = "We couldn't complete your subscription. Please try again in a few moments.";

export default function useNeoEmailSubscriber() {
  const subscribe = async ({
    emailAddress,
    subscriptionType,
    source,
    isLoggedInUser,
  }: subscribeProps): Promise<NeoSubscribeResponse | Error> => {
    try {
      const response = await fetch("/rest/neo/subscription-service/subscribe", {
        credentials: "include",
        method: "POST",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        redirect: "follow",
        body: JSON.stringify({
          emailAddress: emailAddress,
          subscriptionType: subscriptionType,
          source: source,
          isLoggedInUser: isLoggedInUser,
        }),
      });
      if (response.ok === true) {
        const payload = (await response.json()) as NeoSubscribeResponse;
        return payload;
      } else {
        return new Error(`HTTP ${response.status}`);
      }
    } catch (error) {
      return new Error("Network error");
    }
  };
  return subscribe;
}

/** neo's subscription-service still answers with the legacy CallHeader envelope. */
interface NeoSubscribeResponse {
  CallHeader: { StatusCode: string };
}

interface subscribeProps {
  emailAddress: string;
  subscriptionType: string;
  source: string;
  isLoggedInUser: 0 | 1;
}
